import { render, staticRenderFns } from "./ContractChatConfirmData.vue?vue&type=template&id=b4797a72&scoped=true&lang=pug"
import script from "./ContractChatConfirmData.vue?vue&type=script&lang=js"
export * from "./ContractChatConfirmData.vue?vue&type=script&lang=js"
import style0 from "./ContractChatConfirmData.vue?vue&type=style&index=0&id=b4797a72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4797a72",
  null
  
)

export default component.exports